import isPlainObject from 'lodash/isPlainObject'

export default function isEmpty (v) {
  return {
    object: () =>
      v === null ||
      v instanceof Array && v.length === 0 ||
      isPlainObject(v) && Object.getOwnPropertyNames(v).length === 0,
    number: () => isNaN(v),
    string: () => v === '',
    undefined: () => true,
    boolean: () => false,
    symbol: () => false,
    bigint: () => false
  }[typeof v]()
}
